import { PackagePlus, Scale, Calculator, Smartphone, BellRing } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

const STEPS = [
  { icon: PackagePlus, title: "Vous placez vos pièces", text: "Chaque compartiment accueille un type de pièce ou de consommable." },
  { icon: Scale, title: "Le système mesure le poids", text: "Le concept prévoit une mesure indépendante pour chaque compartiment." },
  { icon: Calculator, title: "La quantité est estimée", text: "Le nombre de pièces restantes est estimé à partir du poids mesuré." },
  { icon: Smartphone, title: "L'application suit votre stock", text: "Vos niveaux de stock sont visibles en un coup d'œil." },
  { icon: BellRing, title: "Vous recevez une alerte", text: "Une notification lorsque le niveau devient faible. Avant la rupture." },
];

export default function Solution() {
  return (
    <section id="solution" className="py-16 sm:py-24 bg-[#141619]/40 border-y border-[#2E333D]/50" data-testid="solution-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>La solution</Eyebrow>
          <SectionTitle>STOCKBOX 8 automatise le suivi de vos petites pièces.</SectionTitle>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div className="relative h-full border border-[#2E333D] bg-[#0C0D0E] rounded-xl p-6 group hover:border-[#FFC700]/50 transition-colors" data-testid={`solution-step-${i + 1}`}>
                <span className="font-mono text-[10px] text-gray-600 uppercase tracking-widest">Étape {i + 1}</span>
                <div className="mt-4 w-11 h-11 rounded-lg bg-[#FFC700]/10 border border-[#FFC700]/30 flex items-center justify-center group-hover:bg-[#FFC700]/20 transition-colors">
                  <s.icon size={20} className="text-[#FFC700]" />
                </div>
                <h3 className="mt-4 font-display text-lg font-bold uppercase text-[#F9FAFB] leading-snug">{s.title}</h3>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
